import { Injectable, OnDestroy } from '@angular/core';
import { Store } from '@ngxs/store';
import { Subject, takeUntil } from 'rxjs';
import { ControlTowerState } from '../../../modules/control-tower/store/control-tower.state';
import { AbilityGeneratorService } from './ability-generator.service';

@Injectable({ providedIn: 'root' })
export class AbilityUpdaterService implements OnDestroy {
  private destroy$ = new Subject<void>();

  constructor(
    private store: Store,
    private abilityService: AbilityGeneratorService
  ) {
    this.initializeAbilityUpdates();
  }

  private initializeAbilityUpdates(): void {
    this.store
      .select(ControlTowerState.getEffectiveScopes)
      .pipe(takeUntil(this.destroy$))
      .subscribe(scopes => {
        if (scopes) {
          this.abilityService.updateAbility(scopes || []);
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
